<template>
    <div class="">
        <h5>Filter by</h5>
        <div class="uk-grid" v-for="(filter, filterIndex) in filters" :key="filter.id" uk-toggle="cls: uk-grid-xsmall; mode: media; media: (max-width: 560px)">
            <div class="uk-visible@m uk-margin-small-bottom">
                <div>{{ $t("filters." + filterIndex) }}</div>
                <dr-checkbox
                    v-for="(filterItem, itemIndex) in filter.items"
                    :key="itemIndex"
                    :filterItem="filterItem"
                    :filterItemKey="filterItem.label | array_key"
                    :itemIndex="itemIndex"
                    :filterIndex="filterIndex"
                    :filterId="filter.id"
                />
            </div>
            <div class="uk-hidden@m uk-width-1-1">
                <dr-dropdown-checkboxes
                    :activeFilters="activeFilters"
                    :filterId="filter.id"
                    :filterIndex="filterIndex">
                    <dr-checkbox
                        v-for="(filterItem, itemIndex) in filter.items"
                        :key="itemIndex"
                        :filterItem="filterItem"
                        :filterItemKey="filterItem.label | array_key"
                        :itemIndex="itemIndex"
                        :filterIndex="filterIndex"
                        :filterId="filter.id"
                    />
                </dr-dropdown-checkboxes>
            </div>
        </div>
    </div>
</template>

<script>
    import Checkbox from "./Checkbox.vue";
    import DropdownCheckboxes from "./Dropdown-checkboxes.vue";
    import { mapGetters } from "vuex";

    export default {
        name: "dr-checkbox-group",
        components: {
            'dr-checkbox': Checkbox,
            'dr-dropdown-checkboxes': DropdownCheckboxes
        },
        computed: {
            ...mapGetters([
                'filters',
                'activeFilters'
            ]),
        }
    }
</script>

<style lang="scss">

</style>
